var _rect, _rect2, _path, _path2, _path3, _rect3, _path4, _path5, _path6, _path7, _path8, _path9, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelasCelulares(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "\xCDcone de tela com HTML") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 34,
    height: 38,
    rx: 3,
    stroke: "#4B5055",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 26,
    height: 2,
    rx: 1,
    fill: "#4B5055",
    opacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16 L17 16",
    stroke: "#4B5055",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 16 L18.8 18 L20 16",
    stroke: "#4B5055",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16 L24 16",
    stroke: "#4B5055",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 22,
    height: 0.8,
    fill: "#4B5055",
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24 L20 24",
    stroke: "#4B5055",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24 L26 24",
    stroke: "#4B5055",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28 L16 28",
    stroke: "#4B5055",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28 L20 28",
    stroke: "#4B5055",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    opacity: 0.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28 L24 28",
    stroke: "#4B5055",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 32 L22 32",
    stroke: "#4B5055",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 36,
    width: 10,
    height: 1.5,
    rx: 0.75,
    fill: "#4B5055",
    opacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelasCelulares);
export default __webpack_public_path__ + "static/media/telas_celulares.1b486ec672b3b1ebd0ead0306445b1c8.svg";
export { ForwardRef as ReactComponent };